import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import { Rodeo } from '../../../../model/rodeo';
import { RodeoEvent } from '../../../../model/rodeoEvent';
import { RodeoEventCarryOver } from '../../../../model/rodeoEventCarryOver';

@Component({
    selector: 'new-carryover',
    templateUrl: 'new-carryover.html'
})
export class NewCarryOver {
    rodeo: Rodeo;
    fromRodeoEvent: RodeoEvent;
    fromRound: number;
    toRodeoEvent: RodeoEvent;
    toRound: number;

    newCarryOver: RodeoEventCarryOver;

    fromRounds: any[];
    toRounds: any[];

    constructor(navParams: NavParams, private viewController: ViewController) {
        this.fromRodeoEvent = navParams.get('fromRodeoEvent');
        this.rodeo = navParams.get('rodeo');

        this.toRodeoEvent = this.rodeo.rodeoEvents.filter(x => x.id != this.fromRodeoEvent.id)[0];

        this.fromRounds = [];
        for (var i = 1; i <= this.fromRodeoEvent.rounds; i++) {
            this.fromRounds.push(i);
        }

        if (this.fromRodeoEvent.shortGo)
            this.fromRounds.push(this.fromRodeoEvent.rounds + 1);

        this.updateToClass();

        this.newCarryOver = new RodeoEventCarryOver();
        this.newCarryOver.rodeoEventId = this.fromRodeoEvent.id;
        this.newCarryOver.carryOverId = this.toRodeoEvent.id;
        this.newCarryOver.carryOver = this.toRodeoEvent;
        this.newCarryOver.sourceRound = 1;
        this.newCarryOver.destinationRound = 1;
    }

    updateToClass() {
        this.toRounds = [];
        for (var i = 1; i <= this.toRodeoEvent.rounds; i++) {
            this.toRounds.push(i);
        }

        if (this.toRodeoEvent.shortGo)
            this.toRounds.push(this.toRodeoEvent.rounds + 1);
    }

    create() {
        this.newCarryOver.carryOverId = this.toRodeoEvent.id;
        this.newCarryOver.carryOver = this.toRodeoEvent;
        this.viewController.dismiss(this.newCarryOver);
    }

    cancel() {
        this.viewController.dismiss(null);
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/settings/new-carryover.ts